<template>
  <base-dialog :show-dialog="showDialog">
    <template v-slot:body>
      <v-card class="pt-4 pb-2">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                placeholder="Nome da Pessoa Física ou Jurídica"
                label="Cliente"
                class="text-caption ml-1"
                @input="searchCompany($event)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-data-table
              dense
              dark
              hide-default-footer
              :headers="selectedHeaderOptions"
              :items="companyList"
              :loading="loadingItems"
              :items-per-page="10"
            >
              <template v-slot:item.pin="{ item }">
                <v-btn-toggle tile>
                  <v-btn fab color="warning" x-small @click="pinObject(item)">
                    <v-icon color="white">
                      mdi-pin-outline
                    </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="$emit('close')" class="mt-1">
            <span class="white--text">
              Fechar
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
export default {
  components: { BaseDialog },
  computed: {
    ...mapState('companyModule', ['loadingItems', 'pagination', 'companyList']),
    selectedHeaderOptions() {
      return [
        {
          text: 'CODIGO',
          value: 'CODIGO',
        },
        {
          text: 'NOME',
          value: 'NOME',
        },
        {
          text: 'Ações',
          value: 'pin',
          align: 'right',
        },
      ]
    },
  },
  data: () => {
    return {
      timer: null,
    }
  },
  methods: {
    ...mapActions({
      getCompanies: 'companyModule/getCompanies',
    }),
    pinObject(item) {
      this.$emit('object-pin', item)
    },
    searchCompany($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event ? $event : null
          let obj = parseInt(param)
            ? { page: 1, codigo: param }
            : { page: 1, nome: param }
          console.log(obj)
          this.getDados(obj)
        }, 600)
      } catch (error) {
        console.log(error)
      }
    },
    async getDados(object) {
      try {
        await this.getCompanies(object)
      } catch (error) {
        this.$toasted.show(error,{type:'error'});
      }
    },
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
